import React from 'react';
import { colors, spacing, typography } from '../../../design-system/index.js';

export const AvatarHero = () => {
  const heroStyles = {
    position: 'relative',
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    backgroundImage: `linear-gradient(135deg, ${colors.background.primary} 0%, ${colors.background.secondary} 100%)`,
    overflow: 'hidden',
  };

  const backgroundPatternStyles = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    opacity: 0.03,
    backgroundImage: `radial-gradient(circle at 50% 50%, ${colors.text.primary} 1px, transparent 1px)`,
    backgroundSize: '32px 32px',
    pointerEvents: 'none',
  };

  const avatarContainerStyles = {
    position: 'relative',
    marginBottom: spacing[8],
    zIndex: 2,
  };

  const avatarStyles = {
    width: '200px',
    height: '200px',
    borderRadius: '50%',
    backgroundColor: colors.primary[300],
    border: `4px solid ${colors.text.primary}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: typography.fontSize['3xl'],
    fontWeight: typography.fontWeight.light,
    color: colors.text.inverse,
    boxShadow: `0 20px 40px rgba(0, 0, 0, 0.3)`,
    transition: 'transform 0.3s ease',
    cursor: 'pointer',
  };

  const avatarHoverEffect = {
    '&:hover': {
      transform: 'scale(1.05) translateY(-5px)',
    }
  };

  const glowStyles = {
    position: 'absolute',
    top: '-20px',
    left: '-20px',
    right: '-20px',
    bottom: '-20px',
    borderRadius: '50%',
    background: `radial-gradient(circle, ${colors.alpha.light12} 0%, transparent 70%)`,
    zIndex: -1,
    animation: 'pulse 3s ease-in-out infinite',
  };

  return (
    <section style={heroStyles} className="avatar-hero">
      <div style={backgroundPatternStyles} />
      
      <div style={avatarContainerStyles}>
        <div style={glowStyles} />
        <div 
          style={avatarStyles}
          className="avatar-img"
          onMouseEnter={(e) => {
            e.target.style.transform = 'scale(1.05) translateY(-5px)';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'scale(1) translateY(0)';
          }}
        >
          头像
        </div>
      </div>

      {/* 添加CSS动画 */}
      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 0.3; transform: scale(1); }
          50% { opacity: 0.6; transform: scale(1.05); }
        }
        
        .avatar-hero {
          animation: fadeIn 1s ease-out;
        }
        
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </section>
  );
};
